module.exports = __webpack_public_path__ + "static/media/13_crisalide.ab54597a.jpg";